import useFeatureFlags from 'hooks/useFeatureFlags'
import InitialAssessmentEditForm from './InitialAssessmentEditForm'

export const InitialAssessmentEditFormWrapper = () => {
  const pbsFlagEnabled = useFeatureFlags(
    { flagNames: ['pbs'] as const }
  )?.data?.pbs.enabled

  // @ts-ignore
  return <InitialAssessmentEditForm pbsFlagEnabled={pbsFlagEnabled} />
}
